import { render, staticRenderFns } from "./PecHistory.vue?vue&type=template&id=f52cac54"
import script from "./PecHistory.vue?vue&type=script&lang=js"
export * from "./PecHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports